import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (!name || !email || !confirmEmail || !password) {
    setError("Please fill in all fields.");
    return;
  }

  if (email !== confirmEmail) {
    setError("Email and Re-enter Email must match.");
    return;
  }

  setLoading(true);

  const result = await register(name, email, password);

  if (result.success) {
    navigate("/");
  } else {
    setError(result.error || "Registration failed. Please try again.");
  }

  setLoading(false);
};


  return (
    <div className="auth-page">
      <div className="auth-inner">
        {/* Left side content */}
        <div className="auth-left">
          <h1 className="auth-title">Get a free account</h1>
          <p className="auth-subtitle">
            Over 50 lakh investors use StockAnalyzer for finding and tracking
            stock ideas.
          </p>
          <p className="auth-small">
            Already registered? <Link to="/login">Login here.</Link>
          </p>

          <blockquote className="auth-quote">
            “I started investing at the age of 11. I was late!”
            <br />
            <span>Warren Buffett</span>
          </blockquote>
        </div>

        {/* Right form card */}
        <div className="auth-card">
          {/* <button type="button" className="auth-google-btn">
            Register using Google
          </button>

          <div className="auth-divider">
            <span>or using email</span>
          </div> */}

          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="auth-error">{error}</div>}

            <label className="auth-label">
              Name
              <input
                className="auth-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                required
              />
            </label>

            <label className="auth-label">
              Email
              <input
                type="email"
                className="auth-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </label>
<label className="auth-label">
  Re-enter Email
  <input
    type="email"
    className="auth-input"
    value={confirmEmail}
    onChange={(e) => setConfirmEmail(e.target.value)}
    placeholder="Re-enter your email"
    required
  />
</label>

            <label className="auth-label">
              Password
              <input
                type="password"
                className="auth-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Create a password"
                required
              />
            </label>

            <p className="auth-small">
              By registering you agree to the Terms of Use and have read the
              Privacy Policy.
            </p>

            <button
              type="submit"
              className="auth-primary-btn"
              disabled={loading}
            >
              {loading ? "Creating account..." : "Create account"}
            </button>

            <p className="auth-small center">
              Already registered? <Link to="/login">Login here.</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
